export function isStockable(campagne) {
    return typeof campagne?.stockable === 'boolean'
        ? campagne.stockable
        : campagne?.tombola === true;
}
